import React, { useEffect, useState, useContext, useRef } from 'react';
import Quotes from './Quotes';
import { useNavigate } from 'react-router-dom';
import { QuoteContext } from './../assets/context/QuoteContext';
import tailLift from '../assets/Taillift.svg'
import forkLift from '../assets/Fork Lift.svg'
import tailLiftLgt from '../assets/Taillift-lgt.svg'
import forkLiftLgt from '../assets/Fork Lift-lgt.svg'
import url from './url';
import DraftSaveControl from './DraftSaveControl';
import ShipmentProtection from './ShipmentProtection';

function CalQuote() {
    const { saveQuote, saveFormData, saveSRDetails, SRDetails, formData: contextFormData } = useContext(QuoteContext);
    const navigate = useNavigate();
    const insuranceChoiceRef = useRef(SRDetails?.insurance || null);
    const insuranceSelectionReadyRef = useRef(!SRDetails?.insurance);

    const handleInsuranceChange = (insurance, isReady) => {
        insuranceChoiceRef.current = insurance;
        insuranceSelectionReadyRef.current = isReady;
        clearQuoteErrors('insurance');
        saveSRDetails({
            ...(SRDetails || {}),
            insurance,
        });
    };
    
    // Initialize with context data if available, otherwise use defaults
    const [formData, setFormData] = useState(() => {
        const defaultData = {
            pickupAddress: '',
            deliveryAddress: '',
            packageType: '',
            weight: '',
            goodsValue: '',
            dangerousGoods: '',
            pickupAddressType: '',
            deliveryAddressType: '',
            length: '',
            width: '',
            height: '',
            specialHandling: '',
            pickupPostcode: '',
            deliveryPostcode: '',
            pickupCity: '',
            deliveryCity: '',
            pickupState: '',
            deliveryState: '',
            originCountry: 'AU',
            destinationCountry: 'AU',
            palletStackable: null
        };
        // Merge context data with defaults (context data takes priority)
        return contextFormData ? { ...defaultData, ...contextFormData } : defaultData;
    });
    
    const [isInternational, setIsInternational] = useState(() => {
        // Check if it's international based on context data
        return contextFormData?.originCountry !== 'AU' || contextFormData?.destinationCountry !== 'AU';
    });
    const [originCountry, setOriginCountry] = useState(contextFormData?.originCountry || 'AU');
    const [destinationCountry, setDestinationCountry] = useState(contextFormData?.destinationCountry || 'AU');
    const [quoteErrors, setQuoteErrors] = useState({});
    const [quoteSubmitError, setQuoteSubmitError] = useState('');
    const clearQuoteErrors = (...fields) => {
        setQuoteErrors((previous) => {
            const next = { ...previous };
            fields.forEach((field) => delete next[field]);
            return next;
        });
    };

    console.log(formData)

    const shouldShowLoadingOptions = () => {
        const weight = parseFloat(formData.weight);
        return weight >= 26 || formData.packageType === 'Pallet';
    };
    const handleLoadingMethodChange = (type, method) => {
        const field = `${type}LoadingMethod`;
        setFormData(prev => ({
            ...prev,
            [field]: method
        }));
        clearQuoteErrors(field);
    };

    const handlePalletStackableChange = (isStackable) => {
        setFormData(prev => ({
            ...prev,
            palletStackable: isStackable
        }));
        clearQuoteErrors('palletStackable');
    };



    const countries = [
        { code: 'AU', name: 'Australia' },
        { code: 'US', name: 'United States' },
        { code: 'GB', name: 'United Kingdom' },
        { code: 'NZ', name: 'New Zealand' },
        { code: 'SG', name: 'Singapore' },
        { code: 'JP', name: 'Japan' },
        { code: 'CN', name: 'China' },
        { code: 'IN', name: 'India' },
        // Add more countries as needed
    ];

    const handleTabSwitch = (isInt) => {
        setIsInternational(isInt);
        if (!isInt) {
            // Reset countries to AU when switching to domestic
            setOriginCountry('AU');
            setDestinationCountry('AU');
            setFormData(prev => ({
                ...prev,
                originCountry: 'AU',
                destinationCountry: 'AU',
                // Clear addresses when switching modes
                pickupAddress: '',
                deliveryAddress: '',
                pickupPostcode: '',
                deliveryPostcode: '',
                pickupCity: '',
                deliveryCity: '',
                pickupState: '',
                deliveryState: ''
            }));

            // Clear the input fields
            const pickupInput = document.getElementById('pickup-address');
            const deliveryInput = document.getElementById('delivery-address');
            if (pickupInput) pickupInput.value = '';
            if (deliveryInput) deliveryInput.value = '';
        }
    };


    // Test APIs
    // const API_KEY = '9dfeec2b-fa5e-43ed-88ac-d95cf98cc285';
    // const API_ENDPOINT = 'https://dev-api.oneworldcourier.com.au/api/v2/Quote';

    useEffect(() => {
        const initializeAutocomplete = async (inputId, type, countryCode) => {
            const input = document.getElementById(inputId);
            if (!input) {
                console.error(`Input element with id ${inputId} not found`);
                return;
            }

            // Remove any existing autocomplete
            const existingAutocomplete = input.getAttribute('data-autocomplete-instance');
            if (existingAutocomplete) {
                window.google.maps.event.clearInstanceListeners(input);
            }

            const autocomplete = new window.google.maps.places.Autocomplete(input, {
                types: ['address'],
                componentRestrictions: { country: countryCode.toLowerCase() },
                fields: ['address_components', 'formatted_address', 'geometry']
            });

            input.setAttribute('data-autocomplete-instance', 'true');

            autocomplete.addListener('place_changed', async () => {
                const place = autocomplete.getPlace();
                console.log('Selected place:', place);

                if (!place.address_components) {
                    console.error('No address components found in the selected place');
                    return;
                }

                let postalCode = '';
                let city = '';
                let state = '';

                // Extract address components
                place.address_components.forEach(component => {
                    const types = component.types;

                    if (types.includes('postal_code')) {
                        postalCode = component.long_name;
                    }
                    if (types.includes('locality') || types.includes('postal_town')) {
                        city = component.long_name;
                    }
                    if (types.includes('administrative_area_level_1')) {
                        state = component.short_name;
                    }
                });

                // If postal code is missing, try reverse geocoding
                if (!postalCode && place.geometry && place.geometry.location) {
                    try {
                        const geocoder = new window.google.maps.Geocoder();
                        const response = await new Promise((resolve, reject) => {
                            geocoder.geocode(
                                {
                                    location: {
                                        lat: place.geometry.location.lat(),
                                        lng: place.geometry.location.lng()
                                    },
                                    componentRestrictions: { country: countryCode }
                                },
                                (results, status) => {
                                    if (status === 'OK') {
                                        resolve(results);
                                    } else {
                                        reject(status);
                                    }
                                }
                            );
                        });

                        // Search through reverse geocoding results
                        for (const result of response) {
                            for (const component of result.address_components) {
                                if (component.types.includes('postal_code')) {
                                    postalCode = component.long_name;
                                    break;
                                }
                            }
                            if (postalCode) break;
                        }
                    } catch (error) {
                        console.error('Reverse geocoding failed:', error);
                    }
                }

                console.log(`Type: ${type}, Country: ${countryCode}, Postcode: ${postalCode}, City: ${city}, State: ${state}`);

                const countrySelect = document.getElementById(type === 'pickup' ? 'originCountry' : 'destinationCountry');
                if (countrySelect && countrySelect.value !== countryCode) return;
                setFormData(prev => ({
                    ...prev,
                    [`${type}Postcode`]: postalCode,
                    [`${type}City`]: city,
                    [`${type}State`]: state,
                    [`${type}Address`]: place.formatted_address || input.value
                }));
                clearQuoteErrors(`${type}Address`);
            });
        };

        if (typeof window !== 'undefined' && window.google && window.google.maps && window.google.maps.places) {
            // Initialize autocomplete for both pickup and delivery based on selected countries
            initializeAutocomplete('pickup-address', 'pickup', originCountry);
            initializeAutocomplete('delivery-address', 'delivery', destinationCountry);
        } else {
            console.error('Google Maps API not loaded properly');
        }
    }, [originCountry, destinationCountry]); // Add dependencies to re-run when countries change

    // Prefill address input fields when component loads with existing context data
    useEffect(() => {
        if (contextFormData?.pickupAddress) {
            const pickupInput = document.getElementById('pickup-address');
            if (pickupInput) pickupInput.value = contextFormData.pickupAddress;
        }
        if (contextFormData?.deliveryAddress) {
            const deliveryInput = document.getElementById('delivery-address');
            if (deliveryInput) deliveryInput.value = contextFormData.deliveryAddress;
        }
    }, [contextFormData]);

    // Add handlers for country changes
    const handleOriginCountryChange = (e) => {
        const countryCode = e.target.value;
        setOriginCountry(countryCode);
        setFormData(prev => ({
            ...prev,
            originCountry: countryCode,
            pickupAddress: '',
            pickupPostcode: '',
            pickupCity: '',
            pickupState: '',
        }));
        clearQuoteErrors('pickupAddress');
    };

    const handleDestinationCountryChange = (e) => {
        const countryCode = e.target.value;
        setDestinationCountry(countryCode);
        setFormData(prev => ({
            ...prev,
            destinationCountry: countryCode,
            deliveryAddress: '',
            deliveryPostcode: '',
            deliveryCity: '',
            deliveryState: '',
        }));
        clearQuoteErrors('deliveryAddress');
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        const field = id === 'pickup-address' ? 'pickupAddress'
            : id === 'delivery-address' ? 'deliveryAddress'
                : id;
        if (field === 'goodsValue') clearQuoteErrors('insurance');
        setFormData(prev => ({
            ...prev,
            [field]: value,
            ...(field === 'pickupAddress' ? { pickupPostcode: '', pickupCity: '', pickupState: '' } : {}),
            ...(field === 'deliveryAddress' ? { deliveryPostcode: '', deliveryCity: '', deliveryState: '' } : {}),
        }));
        const errorsToClear = [field];
        const nextPackageType = field === 'packageType' ? value : formData.packageType;
        const nextWeight = field === 'weight' ? Number(value) : Number(formData.weight);
        if (nextPackageType !== 'Pallet') errorsToClear.push('palletStackable');
        if (!(nextWeight >= 26 || nextPackageType === 'Pallet')) {
            errorsToClear.push('pickupLoadingMethod', 'deliveryLoadingMethod');
        }
        clearQuoteErrors(...errorsToClear);
    };

    const handleRadioChange = (e) => {
        const { name, id } = e.target;
        let value = '';

        // Map radio button selections to appropriate values
        if (name === 'caution') {
            value = id === 'noDanger' ? 'None' :
                id === 'l-battery' ? 'LithiumBattery' : 'Other';
        } else if (name === 'handling') {
            value = id === 'noHandling' ? 'None' :
                id === 'fragile' ? 'Fragile' :
                id === 'liquid' ? 'Liquid' : 'UnusualShape';
        }

        setFormData(prev => ({
            ...prev,
            [name === 'caution' ? 'dangerousGoods' : 'specialHandling']: value
        }));
        const field = name === 'caution' ? 'dangerousGoods' : 'specialHandling';
        clearQuoteErrors(field);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent form submission
        }
    };

    const [isLoading, setIsLoading] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true); // Set isLoading to true before making the API request
        setQuoteSubmitError('');
        saveFormData(formData)
        const isStackable = formData.packageType === 'Pallet' ? formData.palletStackable : false;
        const hasTailLiftOrForklift = (method) => method === 'tailLift' || method === 'forkLift';


        const errors = {};
        const labels = {
            pickupAddress: 'Select a complete pickup address from the suggestions.',
            deliveryAddress: 'Select a complete delivery address from the suggestions.',
            packageType: 'Select a package type.',
            weight: 'Enter a valid weight greater than zero.',
            goodsValue: 'Enter a valid goods value.',
            pickupAddressType: 'Select a pickup address type.',
            deliveryAddressType: 'Select a delivery address type.',
            length: 'Enter a valid length greater than zero.',
            width: 'Enter a valid width greater than zero.',
            height: 'Enter a valid height greater than zero.',
            dangerousGoods: 'Select whether the shipment contains dangerous goods.',
            specialHandling: 'Select a handling requirement or choose None.',
        };
        ['pickupAddress', 'deliveryAddress', 'packageType', 'pickupAddressType', 'deliveryAddressType'].forEach((field) => {
            if (!String(formData[field] ?? '').trim()) errors[field] = labels[field];
        });
        ['weight', 'length', 'width', 'height'].forEach((field) => {
            if (!(Number(formData[field]) > 0)) errors[field] = labels[field];
        });
        if (!(Number(formData.goodsValue) >= 0) || String(formData.goodsValue ?? '').trim() === '') errors.goodsValue = labels.goodsValue;
        if (formData.pickupAddress && (!formData.pickupPostcode || !formData.pickupCity)) errors.pickupAddress = labels.pickupAddress;
        if (formData.deliveryAddress && (!formData.deliveryPostcode || !formData.deliveryCity)) errors.deliveryAddress = labels.deliveryAddress;
        if (!['None', 'LithiumBattery', 'Other'].includes(formData.dangerousGoods)) errors.dangerousGoods = labels.dangerousGoods;
        if (!['None', 'Fragile', 'Liquid', 'UnusualShape'].includes(formData.specialHandling)) errors.specialHandling = labels.specialHandling;
        if (formData.packageType === 'Pallet' && typeof formData.palletStackable !== 'boolean') {
            errors.palletStackable = 'Select whether the pallet is stackable.';
        }
        if (shouldShowLoadingOptions()) {
            if (!formData.pickupLoadingMethod) errors.pickupLoadingMethod = 'Select a pickup loading method.';
            if (!formData.deliveryLoadingMethod) errors.deliveryLoadingMethod = 'Select a delivery loading method.';
        }
        const insurance = insuranceChoiceRef.current;
        if (insurance && (
            !insuranceSelectionReadyRef.current
            || !Number.isFinite(Number(insurance.coverage))
            || Number(insurance.coverage) <= 0
            || Number(insurance.coverage) > Number(formData.goodsValue)
            || !insurance.category
            || !['AllNew', 'AllUsed', 'BothNewAndUsed'].includes(insurance.condition)
        )) {
            errors.insurance = 'Complete the paid insurance selection or turn it off before getting quotes.';
        }

        if (Object.keys(errors).length) {
            setQuoteErrors(errors);
            setIsLoading(false);
            const controlIds = {
                pickupAddress: 'pickup-address',
                deliveryAddress: 'delivery-address',
                dangerousGoods: 'noDanger',
                specialHandling: 'noHandling',
                palletStackable: 'stackable',
                pickupLoadingMethod: 'pickupTailLift',
                deliveryLoadingMethod: 'deliveryTailLift',
                insurance: 'shipment-protection-toggle',
            };
            const firstField = Object.keys(errors)[0];
            requestAnimationFrame(() => document.getElementById(controlIds[firstField] || firstField)?.focus());
            return;
        }
        setQuoteErrors({});




        const requestBody = {
            FromAddress: {
                CountryCode: isInternational ? formData.originCountry : "AU",
                City: formData.pickupCity,
                Postcode: formData.pickupPostcode,
                Province: formData.pickupState,
                AddressType: formData.pickupAddressType,
                TailLiftRequired: formData.weight >= 26 || formData.packageType === 'Pallet'
            },
            ToAddress: {
                CountryCode: isInternational ? formData.destinationCountry : "AU",
                City: formData.deliveryCity,
                Postcode: formData.deliveryPostcode,
                Province: formData.deliveryState,
                AddressType: formData.deliveryAddressType,
                TailLiftRequired: formData.weight >= 26 || formData.packageType === 'Pallet'
            },
            CollectionFromTime: (() => {
                const tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                tomorrow.setHours(10, 0, 0, 0);
                const day = String(tomorrow.getDate()).padStart(2, '0');
                const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
                const year = tomorrow.getFullYear();
                return `${day}/${month}/${year} 10:00`;
            })(),

            BookingPackageType: "NonDocuments",
            DangerousGoods: (formData.dangerousGoods && formData.dangerousGoods !== 'None' && formData.dangerousGoods !== 'Other') ? formData.dangerousGoods : null,
            Warranty: 0,
            DeclaredCurrency: "AUD",
            DeclaredValue: Number(formData.goodsValue),
            AllDuties: true,
            CarrierServiceId: null,
            CarrierId: null,
            MeasurementUnitsSet: "KgCm",
            Items: [
                {
                    PackageType: formData.packageType.toLowerCase(),
                    Quantity: 1,
                    Weight: Number(formData.weight),
                    Length: Number(formData.length),
                    Width: Number(formData.width),
                    Height: Number(formData.height)
                }
            ],
            CarbonNeutral: false,
            NonstackableItems: isStackable,
            RemoveCommercialInvoice: false,
            DeliverySignatureType: "NotRequired"
        };

        console.log('Request Body:', requestBody);

        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${url}/api/quote`, { // Change this line
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token ? { Authorization: `Bearer ${token}` } : {}),
                },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json().catch(() => ({}));
            console.log('Quote Response:', data);
            if (!response.ok) {
                throw new Error(data.message || 'We could not retrieve courier quotes right now. Please try again.');
            }
            if (Array.isArray(data.Quotes) && data.Quotes.length > 0) {
                saveQuote(data, requestBody);
                // Navigate to /display-quote with data as state
                navigate('/Quotes', { state: { data, requestBody } });
            } else {
                setQuoteSubmitError('No couriers are available for these shipment details. Please adjust the shipment and try again.');
            }
            setIsLoading(false);

            // Handle the response data here
        } catch (error) {
            console.error('Error fetching quote:', error);
            setQuoteSubmitError(error.message || 'We could not retrieve courier quotes right now. Please try again.');
            setIsLoading(false);
        }
    };


    const LoadingOptions = ({ type }) => {
        if (!shouldShowLoadingOptions()) return null;
    
        const isPickup = type === 'pickup';
        const loadingMethod = isPickup ? formData.pickupLoadingMethod : formData.deliveryLoadingMethod;
    
        return (
            <div className={`quote-field inp-y-spc anything-dangerous-fields radio-btns ${quoteErrors[`${type}LoadingMethod`] ? 'quote-field-invalid' : ''}`}>
                <div className="row">
                    <div className={`col-lg-${isPickup && formData.packageType === 'Pallet' ? '6' : '12'}`}>
                        <p className='mb-0'>Loading Method</p>
                        <div className="d-flex flex-row">
                            <div className='radio-optn-cntnr'>
                                <input
                                    type="radio"
                                    name={`${type}LoadingMethod`}
                                    id={`${type}TailLift`}
                                    checked={loadingMethod === 'tailLift'}
                                    onChange={() => handleLoadingMethodChange(type, 'tailLift')}
                                />
                                <label htmlFor={`${type}TailLift`}>Tail Lift</label>
                            </div>
                            <div className='radio-optn-cntnr'>
                                <input
                                    type="radio"
                                    name={`${type}LoadingMethod`}
                                    id={`${type}ForkLift`}
                                    checked={loadingMethod === 'forkLift'}
                                    onChange={() => handleLoadingMethodChange(type, 'forkLift')}
                                />
                                <label htmlFor={`${type}ForkLift`}>Fork Lift</label>
                            </div>
                        </div>
                        {quoteErrors[`${type}LoadingMethod`] && <p className="quote-field-error" role="alert">{quoteErrors[`${type}LoadingMethod`]}</p>}
                    </div>
                    {isPickup && formData.packageType === 'Pallet' && (
                        <div className={`col-lg-6 justify-content-between align-items-center ${quoteErrors.palletStackable ? 'quote-option-invalid' : ''}`}>
                            <p className='mb-0'>Pallet</p>
                            <div className="d-flex flex-row">
                                <div className='radio-optn-cntnr'>
                                    <input
                                        type="radio"
                                        name="pallet-stackable"
                                        id="stackable"
                                        checked={formData.palletStackable === true}
                                        onChange={() => handlePalletStackableChange(true)}
                                    />
                                    <label htmlFor="stackable">Stackable</label>
                                </div>
                                <div className='radio-optn-cntnr'>
                                    <input
                                        type="radio"
                                        name="pallet-stackable"
                                        id="non-stackable"
                                        checked={formData.palletStackable === false}
                                        onChange={() => handlePalletStackableChange(false)}
                                    />
                                    <label htmlFor="non-stackable">Non Stackable</label>
                                </div>
                            </div>
                            {quoteErrors.palletStackable && <p className="quote-field-error" role="alert">{quoteErrors.palletStackable}</p>}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <>
            <div className="container quote-builder">
                <div className="quote-page-intro">
                    <div><span className="section-kicker">GET STARTED</span><h2>Find the right way<br /><em>to move it.</em></h2></div>
                    <p>Tell us a little about your shipment and we’ll compare the best available options for you.</p>
                </div>
                <div className="cal-quote-form">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${!isInternational ? 'active' : ''}`}
                                onClick={() => handleTabSwitch(false)}
                                type="button"
                                role="tab"
                            >
                                Domestic
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${isInternational ? 'active' : ''}`}
                                onClick={() => handleTabSwitch(true)}
                                type="button"
                                role="tab"
                            >
                                International
                            </button>
                        </li>
                    </ul>                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabIndex="0">
                            <form onSubmit={handleSubmit} onKeyDown={handleKeyDown} noValidate>
                                {Object.keys(quoteErrors).length > 0 && (
                                    <div className="quote-error-summary" role="alert" aria-live="assertive">
                                        <strong>Please check the highlighted fields.</strong>
                                        <span>{Object.keys(quoteErrors).length} item{Object.keys(quoteErrors).length === 1 ? '' : 's'} need your attention.</span>
                                    </div>
                                )}
                                {quoteSubmitError && (
                                    <div className="quote-error-summary quote-service-error" role="alert" aria-live="assertive">
                                        <strong>We couldn’t get your quotes.</strong>
                                        <span>{quoteSubmitError}</span>
                                    </div>
                                )}
                                <div className="row gx-5">
                                    <div className="col-lg-6">

                                        {isInternational && (
                                            <div className="quote-field inp-y-spc">
                                                <label htmlFor="originCountry">From Origin Country</label>
                                                <select
                                                    id="originCountry"
                                                    value={originCountry}
                                                    onChange={handleOriginCountryChange}
                                                >
                                                    {countries.map(country => (
                                                        <option key={country.code} value={country.code}>
                                                            {country.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}


                                        <div className={`quote-field inp-y-spc position-relative ${quoteErrors.pickupAddress ? 'quote-field-invalid' : ''}`}>
                                            <label htmlFor="pickup-address">Pickup Address</label>
                                            <input type="text" id='pickup-address' placeholder='Location or postal code' value={formData.pickupAddress} onChange={handleInputChange} aria-invalid={Boolean(quoteErrors.pickupAddress)} aria-describedby={quoteErrors.pickupAddress ? 'pickup-address-error' : undefined} />
                                            <div className="pickup-addr-suggestions addr-suggestions d-none">
                                                <span></span>
                                            </div>
                                            {quoteErrors.pickupAddress && <p id="pickup-address-error" className="quote-field-error" role="alert">{quoteErrors.pickupAddress}</p>}
                                        </div>
                                        <div className="inp-y-spc quote-field dimension-fields">
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="d-flex flex-column">
                                                        <label htmlFor="pckg-type">Package Details</label>
                                                        <select
                                                            className={quoteErrors.packageType ? 'field-error' : ''}
                                                            id="packageType"
                                                            value={formData.packageType}
                                                            onChange={handleInputChange}
                                                            aria-invalid={Boolean(quoteErrors.packageType)}
                                                        >
                                                            <option value="">Package Type</option>
                                                            <option value="Carton">Carton</option>
                                                            <option value="Bag">Bag</option>
                                                            <option value="Envelope">Envelope</option>
                                                            <option value="Crate">Crate</option>
                                                            <option value="Drum">Drum</option>
                                                            <option value="Roll">Roll</option>
                                                            <option value="Pallet">Pallet</option>
                                                            <option value="Box">Box</option>
                                                            <option value="Satchel">Satchel</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="d-flex flex-column">
                                                        <label htmlFor="pckg-weight">Weight in KGs</label>
                                                        <input
                                                            className={quoteErrors.weight ? 'field-error' : ''}
                                                            type="text"
                                                            id="weight"  // Match this with the formData key
                                                            placeholder="in KGs"
                                                            value={formData.weight}  // Bind value to formData's weight
                                                            onChange={handleInputChange}  // Attach the onChange handler
                                                            aria-invalid={Boolean(quoteErrors.weight)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="d-flex flex-column">
                                                        <label htmlFor="goodsValue">Goods Value in $</label>
                                                        <input
                                                            className={quoteErrors.goodsValue ? 'field-error' : ''}
                                                            type="text"
                                                            id="goodsValue"
                                                            placeholder="Goods Value"
                                                            value={formData.goodsValue}
                                                            onChange={handleInputChange}
                                                            aria-invalid={Boolean(quoteErrors.goodsValue)}
                                                            aria-describedby={Number(formData.goodsValue) > 250 ? 'goods-value-insurance-warning' : undefined}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`quote-field inp-y-spc anything-dangerous-fields radio-btns ${quoteErrors.dangerousGoods || quoteErrors.pickupAddressType ? 'quote-field-invalid' : ''}`}>
                                            <div className="row">
                                                <div className='col-lg-8'>
                                                    <p className='mb-0'>Anything Dangerous</p>
                                                    <div className="d-flex flex-row">
                                                        <div className='radio-optn-cntnr'>
                                                            <input type="radio" name="caution" id="noDanger" onChange={handleRadioChange} checked={formData.dangerousGoods === 'None'} />
                                                            <label htmlFor="noDanger">No</label>
                                                        </div>
                                                        <div className='radio-optn-cntnr'>
                                                            <input type="radio" name="caution" id="l-battery" onChange={handleRadioChange} checked={formData.dangerousGoods === 'LithiumBattery'} />
                                                            <label htmlFor="l-battery">Lithium Battery</label>
                                                        </div>
                                                        <div className='radio-optn-cntnr'>
                                                            <input type="radio" name="caution" id="OtherDanger" onChange={handleRadioChange} checked={formData.dangerousGoods === 'Other'} />
                                                            <label htmlFor="OtherDanger">Other</label>
                                                        </div>
                                                    </div>
                                                    {quoteErrors.dangerousGoods && <p className="quote-field-error" role="alert">{quoteErrors.dangerousGoods}</p>}
                                                </div>
                                                <div className='col-lg-4 d-flex justify-content-between align-items-center'>
                                                    <select
                                                        className={quoteErrors.pickupAddressType ? 'field-error' : ''}
                                                        id="pickupAddressType"
                                                        value={formData.pickupAddressType}
                                                        onChange={handleInputChange}
                                                        aria-invalid={Boolean(quoteErrors.pickupAddressType)}
                                                    >
                                                        <option value="" disabled>Pickup Address Type</option>
                                                        <option value="Residential">Residential</option>
                                                        <option value="Commercial">Commercial</option>
                                                        <option value="Air & Sea Depot">Air & Sea Depot</option>
                                                    </select>
                                                </div>
                                            </div>

                                        </div>
                                        <LoadingOptions type="pickup" />
                                    </div>
                                    <div className="col-lg-6">
                                        {isInternational && (
                                            <div className="quote-field inp-y-spc">
                                                <label htmlFor="destinationCountry">To Destination Country</label>
                                                <select
                                                    id="destinationCountry"
                                                    value={destinationCountry}
                                                    onChange={handleDestinationCountryChange}
                                                >
                                                    {countries.map(country => (
                                                        <option key={country.code} value={country.code}>
                                                            {country.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                        <div className={`quote-field inp-y-spc position-relative ${quoteErrors.deliveryAddress ? 'quote-field-invalid' : ''}`}>
                                            <label htmlFor="delivery-address">Delivery Address</label>
                                            <input type="text" id='delivery-address' placeholder='Location or postal code' value={formData.deliveryAddress} onChange={handleInputChange} aria-invalid={Boolean(quoteErrors.deliveryAddress)} aria-describedby={quoteErrors.deliveryAddress ? 'delivery-address-error' : undefined} />
                                            <div className="delivery-addr-suggestions addr-suggestions d-none">
                                                <span></span>
                                            </div>
                                            {quoteErrors.deliveryAddress && <p id="delivery-address-error" className="quote-field-error" role="alert">{quoteErrors.deliveryAddress}</p>}
                                        </div>
                                        <div className="inp-y-spc quote-field dimension-fields dim-fields">
                                            <label htmlFor="">Dimensions in CM <span> (Volume 0.000m)</span></label>
                                            <div className="d-flex justify-content-between">
                                                <div className="row">
                                                    <div className="col-lg-4">
                                                        <input
                                                            className={quoteErrors.length ? 'field-error' : ''}
                                                            type="text"
                                                            id="length"
                                                            placeholder="Length"
                                                            value={formData.length}
                                                            onChange={handleInputChange}
                                                            aria-invalid={Boolean(quoteErrors.length)}
                                                        />
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <input
                                                            className={quoteErrors.width ? 'field-error' : ''}
                                                            type="text"
                                                            id="width"
                                                            placeholder="Width"
                                                            value={formData.width}
                                                            onChange={handleInputChange}
                                                            aria-invalid={Boolean(quoteErrors.width)}
                                                        />
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <input
                                                            className={quoteErrors.height ? 'field-error' : ''}
                                                            type="text"
                                                            id="height"
                                                            placeholder="Height"
                                                            value={formData.height}
                                                            onChange={handleInputChange}
                                                            aria-invalid={Boolean(quoteErrors.height)}
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className={`quote-field inp-y-spc anything-dangerous-fields radio-btns ${quoteErrors.specialHandling || quoteErrors.deliveryAddressType ? 'quote-field-invalid' : ''}`}>
                                            <div className="row">
                                                <div className='col-lg-8'>
                                                    <p className='mb-0' >Special Handling</p>
                                                    <div className=" d-flex flex-row">
                                                        <div className='radio-optn-cntnr'>
                                                            <input type="radio" name="handling" id="noHandling" onChange={handleRadioChange} checked={formData.specialHandling === 'None'} />
                                                            <label htmlFor="noHandling">None</label>
                                                        </div>
                                                        <div className='radio-optn-cntnr'>
                                                            <input type="radio" name="handling" id="fragile" onChange={handleRadioChange} checked={formData.specialHandling === 'Fragile'} />
                                                            <label htmlFor="fragile">Fragile</label>
                                                        </div>
                                                        <div className='radio-optn-cntnr'>
                                                            <input type="radio" name="handling" id="liquid" onChange={handleRadioChange} checked={formData.specialHandling === 'Liquid'} />
                                                            <label htmlFor="liquid">Liquid</label>
                                                        </div>
                                                        <div className='radio-optn-cntnr'>
                                                            <input type="radio" name="handling" id="un-shape" onChange={handleRadioChange} checked={formData.specialHandling === 'UnusualShape'} />
                                                            <label htmlFor="un-shape">Unusual Shape</label>
                                                        </div>
                                                    </div>
                                                    {quoteErrors.specialHandling && <p className="quote-field-error" role="alert">{quoteErrors.specialHandling}</p>}
                                                </div>
                                                <div className='col-lg-4 d-flex justify-content-between align-items-center'>
                                                    <select
                                                        className={quoteErrors.deliveryAddressType ? 'field-error' : ''}
                                                        id="deliveryAddressType"
                                                        value={formData.deliveryAddressType}
                                                        onChange={handleInputChange}
                                                        aria-invalid={Boolean(quoteErrors.deliveryAddressType)}
                                                    >
                                                        <option value="" disabled>Delivery Address Type</option>
                                                        <option value="Residential">Residential</option>
                                                        <option value="Commercial">Commercial</option>
                                                        <option value="Air & Sea Depot">Air & Sea Depot</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <LoadingOptions type="delivery" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <ShipmentProtection
                                            goodsValue={formData.goodsValue}
                                            initialInsurance={SRDetails?.insurance}
                                            selectionOnly
                                            onInsuranceChange={handleInsuranceChange}
                                        />
                                        {quoteErrors.insurance && <p className="quote-field-error" role="alert">{quoteErrors.insurance}</p>}
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-smth" disabled={isLoading}>
                                    {isLoading ? 'Loading...' : 'Get Quote'}
                                </button>
                        <DraftSaveControl
                            currentStep="quote"
                            overrides={{
                                formData,
                                srDetails: { ...(SRDetails || {}), insurance: insuranceChoiceRef.current },
                            }}
                        />

                            </form>
                        </div>
                        <div className="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabIndex="0">...</div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default CalQuote
